import React from 'react';
import styles from './FormTextField.module.scss';
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    IconButton,
} from '@material-ui/core';
import { Close, DragIndicator } from '@material-ui/icons';

interface FormSingleChoiceFieldProps {
    id: string;
    title: string;
    value: string;
    label?: boolean;
    isRequired?: boolean;
    isDraggable?: boolean;
    isRemovable?: boolean;
    isEditable?: boolean;
    options: any[];
    onClick?: (_id: string) => void;
    onChange: (_key: string, _value: string) => void;
    onRemove?: (_key: string) => void;
};

const FormSingleChoiceField = ({
    id,
    title,
    value,
    label,
    isRequired = false,
    isDraggable = false,
    isRemovable = false,
    isEditable = false,
    options,
    onClick,
    onChange,
    onRemove,
}: FormSingleChoiceFieldProps) => {
    const [selected, setSelected] = React.useState<string>(value || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setSelected(newValue);
        onChange(id, newValue);
    };

    const clickHanlder = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target;
        if (target instanceof HTMLButtonElement || target instanceof SVGElement) {
            return;
        }
        isEditable && onClick && onClick(id);
    };

    return (
        <div className={styles.containerChoice}
            onClick={clickHanlder}
            style={{ cursor: isEditable && onClick ? "pointer" : "default" }}>
            <FormControl component="fieldset">
                {label && (
                    <div className={styles.choiceTitle}>
                        {title}
                        {isRequired && <span style={{ color: 'red' }}> *</span>}
                    </div>
                )}
                <RadioGroup value={selected} onChange={handleChange}>
                    {options.map((option) => (
                        <FormControlLabel
                            key={option}
                            value={option}
                            control={<Radio color="primary" style={{ marginLeft: '0.5rem' }} />}
                            label={option}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
            {(isDraggable || isRemovable) &&
                <div className={styles.actions}>
                    {isRemovable && onRemove &&
                        <IconButton onClick={() => onRemove(id)}>
                            <Close />
                        </IconButton>
                    }
                    {isDraggable &&
                        <IconButton>
                            <DragIndicator />
                        </IconButton>
                    }
                </div>
            }
        </div>
    );
};

export default FormSingleChoiceField;
